// src/hooks/useSettingsRolesPermissions.ts
import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { SETTINGS_PERMISSIONS } from '../constants/permissions.constants';

/**
 * Hook for role-management UI actions.
 *
 * Roles is menu-only (todo o nada): `settings.roles-management.view` grants
 * add / edit / delete / block. Granular `.add` / `.edit` / etc. are not assignable.
 */
export const useSettingsRolesPermissions = () => {
  const canManageRoles = usePermission(SETTINGS_PERMISSIONS.ROLES.VIEW);

  return useMemo(
    () => ({
      canAddRole: canManageRoles,
      canEditRole: canManageRoles,
      canDeleteRole: canManageRoles,
      canBlockRole: canManageRoles,
    }),
    [canManageRoles],
  );
};
